import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageResolverService } from 'src/app/service/page-resolver.service';

const contentPageComponentIds = [
  'articlePage',
  'cookiePolicyPage',
  'internalServerErrorPage'
];


@Component({
  selector: 'dynamic-page-loader',
  template: `
    <ng-container *ngIf="data">
      <app-home *ngIf="componentId === 'homePage'" [data]="data"></app-home>
      <app-content *ngIf="componentId === 'contentPage'" [data]="data"></app-content>
      <app-not-found *ngIf="componentId === 'pageNotFoundPage'" [data]="data"></app-not-found>
      <app-search-result *ngIf="componentId === 'searchResultPage'" [data]="data"></app-search-result>
      <app-news-overview-page *ngIf="componentId === 'newsOverviewPage'" [data]="data"></app-news-overview-page>
      <app-news-details *ngIf="componentId === 'newsDetailsPage'" [data]="data"></app-news-details>
      <app-login *ngIf="componentId === 'loginPage'" [data]="data"></app-login>
    </ng-container>
  `
})
export class DynamicPageLoaderComponent {
  data: any;
  componentId = 'pageNotFoundPage';

  constructor(
    protected route: ActivatedRoute,
    private pageResolverService: PageResolverService
  ) { }

  ngOnInit(): void {
    // this.data = this.route.snapshot.data.data;
    this.componentId = this.resolveComponentId(this.data);
    this.route.data.subscribe(data => {
      this.data = data.data;
      this.componentId = this.resolveComponentId(this.data);
    });
  }

  private resolveComponentId(data: any): string {
    const candidate = (data && data.contentTypeAlias) || 'pageNotFoundPage';

    if (this.isKnownComponentId(candidate)) {
      if (this.isContentPage(candidate)) {
        return 'contentPage';
      }
      return candidate;
    }

    return 'pageNotFoundPage';
  }

  private isKnownComponentId(componentId: string): boolean {
    return (
      componentId === 'homePage' ||
      componentId === 'pageNotFoundPage' ||
      componentId === 'searchResultPage' ||
      componentId === 'newsOverviewPage' ||
      componentId === 'newsDetailsPage' ||
      componentId === 'loginPage' ||
      this.isContentPage(componentId)
    );
  }

  isContentPage(componentId: string): boolean {
    return contentPageComponentIds.indexOf(componentId) > -1;
  }
}
